import React, {useState} from 'react';
import {Button, Table} from 'antd';
import {useNavigate} from 'react-router-dom';
import TablePaginationBar from '../../../../components/TablePaginationBar';
import BcpCheckJobFilter from './components/BcpCheckJobFilter';
import {useBcpCheckJobColumns} from './components/BcpCheckJobColumns';
import {useBcpCheckJobListQuery} from './hooks/useBcpCheckJobListQuery';
import {useBcpCheckUserGroups} from './hooks/useBcpCheckUserGroups';
import {CheckJobFilterType} from './graphql/types/BcpCheckJobTypes';

const initialFilters: CheckJobFilterType = {};

const BcpCheckJobListPage: React.FC = () => {
    const navigate = useNavigate();
    const [tempFilters, setTempFilters] = useState<CheckJobFilterType>(initialFilters);
    const [filters, setFilters] = useState<CheckJobFilterType>(initialFilters);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [shouldFetch, setShouldFetch] = useState(true);

    const {data, loading, refetch, totalElements} = useBcpCheckJobListQuery(
        filters,
        currentPage,
        pageSize,
        shouldFetch,
    );

    const userGroupOptions = useBcpCheckUserGroups();

    const columns = useBcpCheckJobColumns({onRefresh: refetch});

    const handleSearch = () => {
        setFilters({...tempFilters});
        setCurrentPage(1);
        setShouldFetch(true);
    };

    const handleReset = () => {
        setTempFilters(initialFilters);
        setFilters(initialFilters);
        setCurrentPage(1);
        setShouldFetch(true);
    };

    const handlePageChange = (page: number, size: number) => {
        setCurrentPage(page);
        setPageSize(size);
    };

    return (
        <div className="bg-white rounded-lg shadow-sm px-3 pb-3 pt-3">
            <h2 className="text-base font-semibold mb-4">核对任务管理</h2>
            <BcpCheckJobFilter
                filters={tempFilters}
                setFilters={setTempFilters}
                userGroupOptions={userGroupOptions}
            />
            <div className="flex gap-2 mb-4">
                <Button type="primary" onClick={handleSearch}>查询</Button>
                <Button onClick={handleReset}>重置</Button>
                <Button
                    type="primary"
                    onClick={() => navigate('/ops-tool/settlement/bcp/check-jobs/create')}
                >
                    新建
                </Button>
            </div>
            <Table
                dataSource={data}
                columns={columns}
                rowKey="id"
                loading={loading}
                pagination={false}
                scroll={{x: 1200}}
            />
            <TablePaginationBar
                total={totalElements}
                current={currentPage}
                pageSize={pageSize}
                onChange={handlePageChange}
            />
        </div>
    );
};

export default BcpCheckJobListPage;
